import React from 'react'
import { SelectChangeEvent } from '@mui/material'

import { Select } from '@/components'
import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import { sbpPaymentsActions } from '@/stores/slices/sbp-payments-slice.ts'

const MENU_ITEMS = [
  { value: 'ALL', label: 'Все' },
  { value: 'NEW', label: 'Новый' },
  { value: 'REJECTED', label: 'Отклонен' },
  { value: 'REVERSED', label: 'Возвращен' },
  { value: 'PAID', label: 'Выполнен / Оплачен' },
]

export const ToBStatusFilter = (): React.ReactElement => {
  const operationState = useAppSelector((state) => state.sbpPayments.operationState)
  const dispatch = useAppDispatch()

  const handleStatusChange = (event: SelectChangeEvent) => {
    dispatch(
      sbpPaymentsActions.setFilter({
        filterKey: 'operationState',
        filterValue: event.target.value === 'ALL' ? '' : event.target.value,
      })
    )
  }

  const selectValue = operationState || 'ALL'

  return (
    <Select value={selectValue} onChange={handleStatusChange} items={MENU_ITEMS} label="Статус" labelId="sbp-status" />
  )
}
